export const EMPTY_MENU_DRAFT = {
    name: '',
    description: '',
    price: '',
    category: 'food',
    available: true,
};
export const MENU_CATEGORIES = [
    { key: 'food', label: 'Food' },
    { key: 'drinks', label: 'Drinks' },
    { key: 'appetizers', label: 'Appetizers' },
    { key: 'desserts', label: 'Desserts' },
    { key: 'hours', label: 'Hours' },
];
export function normalizeMenuCategory(category) {
    return MENU_CATEGORIES.some(({ key }) => key === category)
        ? category
        : 'food';
}
export function filterMenuItems(items, filterCategory, search) {
    const normalizedSearch = search.trim().toLowerCase();
    return items.filter((item) => {
        const matchesCategory = filterCategory === 'all' || item.category === filterCategory;
        const matchesSearch = normalizedSearch === ''
            || item.name.toLowerCase().includes(normalizedSearch)
            || (item.description ?? '').toLowerCase().includes(normalizedSearch);
        return matchesCategory && matchesSearch;
    });
}
export function getMenuStats(items) {
    const available = items.filter((item) => item.available).length;
    const totalPrice = items.reduce((sum, item) => sum + item.price, 0);
    return {
        total: items.length,
        available,
        unavailable: items.length - available,
        averagePrice: items.length > 0 ? totalPrice / items.length : 0,
    };
}
